// Museum009.js
import React from 'react';
import './Alt.css'; // Import your additional CSS

const Museum009 = () => {

  const imageUrl ='https://lh5.googleusercontent.com/p/AF1QipO8VYjvN6byR5Rd5CafFtO0098Nzi1fDBeDF_d1=w408-h544-k-no';

  return (
    <div className="container">
      <div className="post">
        <div className="title-overlay">Museu de Arte ContemporÃ¢nea da Universidade de SÃ£o Paulo</div> {/* Explicitly specify the title here */}
        <img src={imageUrl} alt="Museu de Arte ContemporÃ¢nea da Universidade de SÃ£o Paulo"/>
      </div>
    </div>
  );
};

export default Museum009;
